import React from "react";
import "./ui.scss";

export const Card: React.FC<React.PropsWithChildren<{ title?: string; meta?: string; className?: string }>> = ({ title, meta, className = "", children }) => (
  <div className={`card ${className}`.trim()}>
    {title && <div className="card__header">{title}</div>}
    {meta && <div className="card__meta">{meta}</div>}
    {children}
  </div>
);

export default Card;


